import { setNumOfSyllables, setSearchTxt, setSelectedArticulationSoundPositions, setSelectedArticulationSounds, setSelectedCategories, setSelectedFilter, setSelectedGame, setSelectedGrades, setSelectedThemes, setSyllablesShapes } from "@app/routes/treatmentV3/store/activityLibrarySlice";
import {
  trackVocabularyEvent as TVE,
  trackGamesSelectEvent,
  trackcChangedFilterEvent,
} from "./activityLibrary";

export const relevantLibraryBeforeActions = {

};

export const relevantLibraryAfterActions = {
  [setSelectedFilter]: (_, stateAfter) => {
    TVE("H5P_game_filter_change", stateAfter, { });
  },

  [setSelectedArticulationSounds]: (stateBefore, stateAfter) => {
    trackcChangedFilterEvent(stateAfter, stateBefore, { filter_name: "articulation_sounds" });
  },
  [setSelectedArticulationSoundPositions]: (stateBefore, stateAfter) => {
    trackcChangedFilterEvent(stateAfter, stateBefore, { filter_name: "articulation_sounds_positions" });
  },

  [setSelectedCategories]: (stateBefore, stateAfter) => {
    trackcChangedFilterEvent(stateAfter, stateBefore, { filter_name: "vocabulary_categories" });
  },

  [setSelectedGrades]: (stateBefore, stateAfter) => {
    trackcChangedFilterEvent(stateAfter, stateBefore, { filter_name: "grades" });
  },
  [setSelectedThemes]: (stateBefore, stateAfter) => {
    trackcChangedFilterEvent(stateAfter, stateBefore, { filter_name: "themes" });
  },

  [setNumOfSyllables]: (stateBefore, stateAfter) => {
    trackcChangedFilterEvent(stateAfter, stateBefore, { filter_name: "num_of_syllables" });
  },

  [setSyllablesShapes]: (stateBefore, stateAfter) => {
    trackcChangedFilterEvent(stateAfter, stateBefore, { filter_name: "syllables_shapes" });
  },

  [setSelectedGame]: (stateBefore, stateAfter, action) => {
    const { source } = action?.payload || {};
    const additonalParams = source ? { source } : null;
    trackGamesSelectEvent(stateAfter, stateBefore, additonalParams);
  },
  [setSearchTxt]: (stateBefore, stateAfter) => {
    TVE("H5P_search_game", stateAfter, { });
  },
};
